import { buildAdminApiToken } from '~/utils/jwt/authToken';

export default defineNuxtRouteMiddleware(async () => {
    if (!import.meta.server) {
        return;
    }

    await buildAdminApiToken(useRuntimeConfig().jwtPrivateKey.replace(/\\n/g, '\n'));
});
